import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_27: FaireProductEntity = {
  token: "legacy_prod_abbott-27",
  type: "product",
  name: 'Small Hanging Mouse Dark Brown 2" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/51774b09a87486489c4c9b68a6a9d2796ad2c4010b8e5dda4e4c9b9f1c73f281.jpeg",
  priceDollars: 12,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
